import { PageHeader } from "@/components/PageHeader";

export default function PatrolInspectionPage() {
  return (
    <div className="flex bg-background flex-col">
      <PageHeader title="수회검사" />

      <main className="flex-1 p-6">
        <div className="container mx-auto">
          <p className="text-gray-600 dark:text-gray-400">
            This is patrol-inspection page
          </p>
        </div>
      </main>
    </div>
  );
}
